<!-- 期间管理 -->
<template>
  <div class="periodManage">
    <!-- “periodManage”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
    ></sirui-search>
    <!-- periodManage -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        :rowStyle="rowStyle"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <!-- <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field]|getDictNameByCode(item.dictType)}}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field]|formatTableColumn(item.format)}}
            </span>
            <span v-else>{{scope.row[item.field]}}</span>
          </template> -->
          <template v-slot="{ row, rowIndex }">
            <span v-if="item.dictType">
              {{ row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.field == 'seq'">
              {{ rowIndex + 1 }}
            </span>
            <span v-else-if="item.format">
              {{ row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/periodManage';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  // import { dateFormat } from '@/filters';
  export default {
    name: 'periodManage',
    mixins: [tableMixins],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司
            prop: 'slipCompanyNo',
            name: '公司',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            required: true,
            filterable: true,
          },
          {
            // 分类账名称
            prop: 'ledgerName',
            name: '分类账名称',
            type: 'input',
            placeholder: '选择公司自动带出',
          },
          {
            // 期间状态
            name: '期间状态',
            prop: 'periodStatus',
            type: 'dict',
            dictType: 'gl_period_status',
          },
          {
            // 会计年度
            name: '会计年度',
            prop: 'calendarYear',
            type: 'year',
            format: 'yyyy',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          slipCompanyNo: null, // 公司
          ledgerName: null, // 分类账名称
          ledgerCode: null, // 分类账代码
          periodStatus: null, // 期间状态
          calendarYear: null, // 会计年度
        },
        companyList: [], // 公司列表
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'periodStatus', title: '期间状态', visible: true, dictType: 'gl_period_status' },
          { field: 'calendarYear', title: '会计年度', visible: true },
          { field: 'calendarPeriod', title: '期间', visible: true },
          // { field: "calendarCode", title: '编号', visible: true },
          { field: 'seq', title: '编号', width: '50' },
          { field: 'calendarStartDate', title: '起始日期', visible: true },
          { field: 'calendarEndDate', title: '终止日期', visible: true },
          { field: 'ledgerCode', title: '分类账代码', visible: true },
          { field: 'ledgerName', title: '分类账名称', visible: true },
        ],
      };
    },
    mounted() {
      this.getCompany();
      this.getButtonList();
      this.query.slipCompanyNo = this.userInfo.companyCode;
      this.query.calendarYear = new Date().getFullYear().toString();
      this.getLegerCode(this.query.slipCompanyNo);
    },
    methods: {
      // 获取列表数据
      getData() {
        if (!this.query.calendarYear) {
          return this.tips('请先选择会计年度！', 'error');
        }
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        this.load = true;
        this.$axios.post(API.GET_LIST_FINANCE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取分类账名称
      async getLegerCode(companyCode) {
        let res = await this.$axios.get(API.GET_LEGER_CODE_NAME, { companyCode });
        if (res) {
          if (res.data.code == 0 && res.data.data) {
            let data = res.data.data;
            this.query.ledgerName = data.ledgerName;
            this.query.ledgerCode = data.ledgerCode;
          }
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      //切换公司
      companyChange(val) {
        this.getLegerCode(val.val);
      },
      //行项目样式
      rowStyle({ row }) {
        if (row.periodStatus == 'open') {
          return {
            backgroundColor: 'rgb(151 202 149)',
          };
        }
        if (row.periodStatus == 'Future') {
          return {
            backgroundColor: 'rgb(255,227,190)',
          };
        }
      },
      // 按钮
      chooseClick(type) {
        if (this.multipleSelection.length == 0) {
          return this.tips('您还未选择任何数据！', 'error');
        }
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        this.loading.startLoading();
        if (type == 'open') {
          this.$axios.post(API.OPEN, ids).then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.tips('请注意同步维护或更新资金计息期初余额！', 'warning');
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else if (type == 'close') {
          this.$axios.post(API.CLOSE, ids).then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.tips('请注意同步维护或更新资金计息期初余额！', 'warning');
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else if (type == 'closeInspect') {
          this.$axios.post(API.CLOSE_CHECK, ids).then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              if (res.data.data) {
                window.location.href = res.data.data;
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              }
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: info,
          type: type,
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
